import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "countLabel"]

  declare readonly inputTarget: HTMLInputElement
  declare readonly hasInputTarget: boolean
  declare readonly countLabelTarget: HTMLElement
  declare readonly hasCountLabelTarget: boolean

  private input: HTMLInputElement | HTMLTextAreaElement | null = null
  private label: HTMLElement | null = null
  private createdLabel?: HTMLElement
  private readonly boundUpdate = () => this.update()

  connect() {
    if (this.hasCountLabelTarget) {
      // Explicit markup (e.g. the mobile question modal). The declarative
      // input->character-counter#update action keeps the count in sync.
      this.input = this.hasInputTarget ? this.inputTarget : null
      this.label = this.countLabelTarget
    } else {
      // Auto mode: render an inline counter for the field in this container.
      // Used by the clean profile boxes, where it only shows on focus (CSS).
      // Skip the hidden inputs form_with injects (_method, csrf, font_size);
      // only the response field carries a maxlength.
      this.input = this.element.querySelector("textarea[maxlength], input[maxlength]")
      this.createdLabel = document.createElement("small")
      this.createdLabel.className = "clean-char-counter"
      this.element.appendChild(this.createdLabel)
      this.label = this.createdLabel
      this.input?.addEventListener("input", this.boundUpdate)
    }
    this.update()
  }

  disconnect() {
    this.input?.removeEventListener("input", this.boundUpdate)
    this.createdLabel?.remove()
  }

  update() {
    if (!this.input || !this.label) return
    const maxLength = (this.input as HTMLInputElement).maxLength
    this.label.textContent = maxLength < 0 ? " " : `${this.input.value.length}/${maxLength}`
  }
}
